import React, { useContext } from "react";
import { SettingGeneralContext, SettingGeneralProvider } from "../../../context/settingGeneralContext";
import { Col, Container, Row } from "react-bootstrap";


export default function WellcomeCard({
    children,
}) {
    return (
        <SettingGeneralProvider>
            <WellcomeCardContent
                children={children}
            />
        </SettingGeneralProvider>
    );
}

function WellcomeCardContent({ children }) {
    const { state } = useContext(SettingGeneralContext);

    const boxShadow = state?.showTheme?.app_sidebar_color_3 || "#BFBFBF";
    const colorText = state?.showTheme?.app_sidebar_color_2 || "#001F8B";

    const childrenArray = React.Children.toArray(children);
    const totalChildren = childrenArray.length;

    let colSize = 3; 
    if (totalChildren === 1) colSize = 12;
    else if (totalChildren === 2) colSize = 6;
    else if (totalChildren === 3) colSize = 4;
    else if (totalChildren === 4) colSize = 3;

    return (
        <Row className="w-100 m-0">
            {childrenArray.map((child, index) => (
                <Col key={index} md={colSize} className="text-center p-3">
                    <div
                        style={{
                            backgroundColor: "white",
                            boxShadow: `2px 2px 10px ${boxShadow}`,
                            borderRadius: "10px",
                            padding: "7px",
                            color: colorText,
                            fontSize: "18px",
                        }}
                    >
                        {child}
                    </div>
                </Col>
            ))}
        </Row>
    );
}


